module.exports = __webpack_public_path__ + "img/组 786.13ba78d1.png";